import { render, staticRenderFns } from "./LabelWithIcon.vue?vue&type=template&id=6570fc82&scoped=true&"
import script from "./LabelWithIcon.vue?vue&type=script&lang=js&"
export * from "./LabelWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./LabelWithIcon.vue?vue&type=style&index=0&id=6570fc82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570fc82",
  null
  
)

export default component.exports